module.exports = __webpack_public_path__ + "img/ic_wallet.43958433.svg";